var render = function () {
  var _class;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [!_vm.isExternalCheckoutProvider ? [_c('div', {
    class: _vm.$style.row
  }, [_c('div', {
    class: _vm.$style.box
  }, [_c('p', {
    class: _vm.$style.label,
    domProps: {
      "textContent": _vm._s(_vm.$t('amount.for.refund'))
    }
  }), _c('p', {
    class: _vm.$style.text,
    domProps: {
      "textContent": _vm._s(_vm.displayAmount)
    }
  })]), _c('div', {
    class: _vm.$style.box
  }, [_c('p', {
    class: _vm.$style.label,
    domProps: {
      "textContent": _vm._s(_vm.getCommissionText)
    }
  }), _c('p', {
    class: _vm.$style.text,
    domProps: {
      "textContent": _vm._s(_vm.displayCommission)
    }
  })])])] : _vm._e(), _vm.hasEnoughAmount ? [_c('div', {
    class: _vm.$style.box
  }, [_c('p', {
    class: _vm.$style.label,
    domProps: {
      "textContent": _vm._s(_vm.$t('debited.from.balance'))
    }
  }), _c('p', {
    class: (_class = {}, _class[_vm.$style.text] = true, _class[_vm.$style.large] = true, _class),
    domProps: {
      "textContent": _vm._s(_vm.displayTotal)
    }
  })])] : [_c('div', {
    class: _vm.$style.box
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('not.enough.funds.for.refund', {
        displayAmount: _vm.displayDifference
      }))
    }
  })])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }